import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { RootState } from '../../../store';
import { PayerInitialState } from '../../../store/models/payerListModel';
import { getMappedRoute } from '../../../utils/routeUtility';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../config/formControlConfig';
import { updateFormControlConfig } from '../../../store/actions/payerListAction';
import { IN_PATIENT_NESTED_ROUTE } from '../../../shared/constants/crmConstants';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';

const InPatient = ({ match, location }: any): ReactElement => {
  const dispatch = useDispatch();

  const {
    payer, defaultControlConfig,
  } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { name, isOnMailPayer, isCorporatePayer } = payer || {};
  const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();
  useEffect((): void => {
    const payerFormControlConfig = (CONTROL_CONFIG_BASED_ON_PAYER[name || ''] || {});
    const isArtemisPayer = Object.values(payerFormControlConfig)?.some(
      (config: any): any => config?.type === 'ARTEMIS');

    let newFormControlConfig = { ...defaultControlConfig, ...payerFormControlConfig };
    if (isOnMailPayer || isCorporatePayer) {
      newFormControlConfig = (CONTROL_CONFIG_BASED_ON_PAYER['On-mail-payers-config']) || defaultControlConfig;
    }
    if (isOrionIntegrationEnabledProvider && isArtemisPayer) {
      newFormControlConfig = { ...defaultControlConfig, ...CONTROL_CONFIG_BASED_ON_PAYER['ICICI_Orion'] };

    }
    dispatch(updateFormControlConfig(newFormControlConfig));
  }, [payer, name, updateFormControlConfig, defaultControlConfig]);

  const nextDefaultPage = getMappedRoute(location?.pathname, IN_PATIENT_NESTED_ROUTE()) || IN_PATIENT_NESTED_ROUTE()[0].routeName;

  return <NestedRoute
    match={match}
    defaultPage={nextDefaultPage}
    nestedNav={IN_PATIENT_NESTED_ROUTE()}
  />;
};

export default InPatient;
